<template>
  <div>
    <my-title :img='img' title='企业文化'></my-title>
    <div class="container">
      <img v-for="(item,index) in imgList" :key='index' :src="item.file_path" alt="">
    </div>
    <!-- <div class="culture center">
      <p class="text-indent p">
        广物服务集团自成立以来，始终积极进取、革故鼎新，在前进的道路上不断去超越，不断去创新，不断形成了好的管理积累和好的经验沉淀，这些都构成了广物独特的企业文化，推动广物更好地向前发展。
      </p>
      <div class="culture-img padding-tb-lg clearflx">
        <el-image 
          style="width: 48%;float: left;"
          :src="illustrationList[0]" 
          :preview-src-list="illustrationList">
        </el-image>
        <el-image 
          style="width: 48%;float: right;"
          :src="illustrationList[1]" 
          :preview-src-list="illustrationList">
        </el-image>
      </div>
      <ul class="culture-list">
        <li class="culture-list-item clearflx shadow" v-for="(item, index) in cultureList" :key="index">
          <div class="culture-list-item-title inline-block font-weight fl">{{item.title}}</div>
          <span class='culture-list-item-content fl'>{{item.content}}</span>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import myTitle from '../../components/IntoTheGroup/IntoTheGroup_title'
// import {cultureList} from '../../project.config'
import {selectcatfile} from '../../api/catfile/selectcatfile'
export default {
  data() {
    return {
      img: require('../../assets/img/icon_culture.png'),
      illustrationList: [require('../../assets/img/culture_1.png'),require('../../assets/img/culture_2.png')],
      // cultureList,
      catId: 43,
      imgList: '',
    }
  },
  components: {
    myTitle
  },
  created () {
    this.getCatFile()
  },
  methods: {
    getCatFile() {
      selectcatfile({catId: this.catId}).then(res => {
        if(res.data.length === 0) return;

        this.imgList = res.data;
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  // .culture {
  //   width: 650px;
  //   line-height: 1.6;
  //   p {
  //     width: auto;
  //   }
  //   &-img {
  //     img {
  //       width: 48%;
  //     }
  //   }
  //   &-list {
  //     &-item {
  //       line-height: 43px;
  //       background: #eaeaea;
  //       border-radius: 20px 0 0 20px;
  //       margin-bottom: 20px;
  //       box-shadow: 3px 3px 10px rgba(0,0,0,.3);
  //       &-title {
  //         background: #0099cb;
  //         // padding: 0 20px;
  //         text-align: center;
  //         width: 20%;
  //         border-radius: 20px;
  //         color: #fff;
  //       }
  //       &-content {
  //         padding-left: 30px;
  //         width: 80%;
  //       }
  //     }
  //   }
  // }

  .container {
    width: 800px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  @media screen and(max-width: 1200px) {
    .container {
      // width: 992px;
    }
  }
  @media screen and(max-width: 992px) {
    .container {
      width: 768px;
    }
  }
  @media screen and(max-width: 768px) {
    .container {
      width: 90%;
    }
    // .culture {
    //   width: 90%;
    //   margin: 0 auto;
    //   &-list {
    //     &-item {
    //       border-radius: 20px;
    //       line-height: 1.4;
    //       &-title {
    //         float:initial;
    //         display: block;
    //         width: 100%;
    //         border-radius: 20px 20px 0 0px;
    //         padding: 5px;
    //       }
    //       &-content {
    //         padding: 15px;

    //       }
    //     }
    //   }
    // }
  }
  
</style>